import React from 'react';

type Props = {
	text: string;
	maxLength: number;
};

const CroppedText: React.FC<Props> = ({ text, maxLength }) => {
	return (
		<div
			style={{
				width: '100%',
				maxWidth: `${maxLength}ch`,
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap'
			}}
			title={text}
		>
			{text}
		</div>
	);
};

export default CroppedText;
